const resolvedApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

if (process.env.NODE_ENV === 'production' && !resolvedApiUrl.startsWith('https://')) {
    throw new Error('API_URL must use HTTPS in production');
}

const Config = {
    API_URL: resolvedApiUrl,
    projectRegion: process.env.REACT_APP_AWS_PROJECT_REGION || '',
    cognitoRegion: process.env.REACT_APP_AWS_COGNITO_REGION || '',
    userPoolsId: process.env.REACT_APP_AWS_USER_POOLS_ID || '',
    userPoolsWebClientId: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID || '',
}

export const {
    API_URL,
    projectRegion,
    cognitoRegion,
    userPoolsId,
    userPoolsWebClientId
} = Config;
